import { render, staticRenderFns } from "./OrdOutputProduct.vue?vue&type=template&id=a9c30b40&"
import script from "./OrdOutputProduct.vue?vue&type=script&lang=js&"
export * from "./OrdOutputProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports